import { FilterFilled } from "@ant-design/icons";
import { Button } from "antd";

export const FilterBtn = ({
  displayText = true,
  text = null,
  ...restProps
}) => {
  return (
    <Button
      color="cyan"
      variant="outlined"
      icon={<FilterFilled />}
      {...restProps}
    >
      {displayText && (text == null ? "Filtrar" : text)}
    </Button>
  );
};
